import { Icon } from '@admitkard/ccl/Icon';
import { useRouter } from 'next/router';
import React from 'react';


interface BlogAuthorProfile2Props {
  authorName: string;
  authorAvatar: string;
  description: string;
  experience: string;
  education: string;
  title?: string;
  totalPosts?: number;
  type?: string;
  facebookLink?: string;
  twitterLink?: string;
  linkedinLink?: string;
  openAuthorProfile?: boolean;
  authorSlug?: string;
}

const truncateDescription = (description :string) :string => {
  if(description.length > 30){
    return `${description.slice(0,56)  } ..`;
  }
  return description;
};

const BlogAuthorProfile2 = (props: BlogAuthorProfile2Props) => {
  const router = useRouter();
  const authorDescription = truncateDescription(props.description);
  const handleAuthorClick = () => {
    if (props.openAuthorProfile) {
      router.push(`/blog/author/${props.authorSlug}`);
    }
  };
  return (
    <>
      <div className="author-profile-parent">
        <div className="comment-container">
          <div className="comment-author-avatar">
            {props.authorAvatar && <img src={props.authorAvatar} alt="Avatar" className="avatar" />}
          </div>
          <div className="comment-section">
            <div className="comment-main-container">
              <div className='author-details-container'>
                <div className='author-header'>
                  <div className='author-name-designation'>
                    {props.authorName && (
                      <h2 className="author-name">
                        <span className="author-name-cursor" onClick={() => handleAuthorClick()}>
                          {props.authorName}
                        </span>
                        {props.totalPosts ? (
                          <span className="author-total-post">
                            {props.totalPosts} {props.type}
                          </span>
                        ) : (
                          props.type && <span className="author-total-post">No {props.type}</span>
                        )}
                      </h2>
                    )}
                    <div className="designation-expertise-container">
                      {props.title && <span className="designation">{props.title}&nbsp;<span>&#8226;&nbsp;</span></span>}
                      {props.education && <span className="expertise">{props.education}&nbsp;<span>&#8226;&nbsp;</span></span>}
                      {props.experience && <span className="experience">{props.experience}</span>}
                    </div>
                  </div>
                  <div className="author-social-profiles">
                    {props.facebookLink && (
                      <a href={props.facebookLink} target="_blank" rel="noreferrer">
                        <Icon className='icon-svg' name="facebookLavender" type="color" size='large' />
                      </a>
                    )}
                    {props.twitterLink && (
                      <a href={props.twitterLink} target="_blank" rel="noreferrer">
                        <Icon className='icon-svg' name="twitterLavender" type="color" size="large" />
                      </a>
                    )}
                    {props.linkedinLink && (
                      <a href={props.linkedinLink} target="_blank" rel="noreferrer">
                        <Icon className='icon-svg' name="linkedinLavender" type="color" size="large" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="comment-description">
                {authorDescription}
                <span className="see-more" onClick={() => handleAuthorClick()}>
                  &nbsp;See more
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          * {
            box-sizing: border-box;
            padding: 0rem;
            margin: 0rem;
          }

          .author-profile-parent {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 0rem;
            width:49%;
          }
          .author-heading-container h2 {
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 1.75rem;
            line-height: 2.625rem;
            color: #483287;
          }
          .author-name-designation :{
            display:flex;
            flex-direction:column;
          }
          .author-total-post {
            margin-left: 0.75rem;
            border: 0.0625rem solid #a259ff;
            border-radius: 2rem;
            padding: 0.25rem 0.75rem;
            font-size: 1rem;
          }
          .comment-container {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            width:100%;
            margin-top: 1rem;
            padding:1rem;
            background:#F5F2F9;
            border-radius:0.75rem;
          }
          .author-header {
            display: flex;
            flex-direction: row;
            align-items:flex-start;
            justify-content:space-between;
            width:100%;
          }
          .author-social-profiles {
            margin-left: auto;
          }
          .author-social-profiles a {
            margin-right: 0.5rem;
            cursor: pointer;
          }
          .comment-author-avatar {
            min-width: 2.625rem;
            height: 2.625rem;
            background: #ecdaff;
            border-radius: 50%;
            margin-right: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .comment-author-avatar img {
            width: 2.625rem;
            height: 2.625rem;
            border-radius: 50%;
          }
          .comment-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width:100%;
          }
          .comment-main-container{
            width:100%;
          }
          .author-name {
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 1.25rem;
            color: #483287;
            line-height: 1.875rem;
          }
          .author-name-cursor {
            cursor: ${props.openAuthorProfile ? 'pointer' : 'default'};
          }
          .comment-description {
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.5rem;
            color: #33434a;
            padding-top: 0.75rem;
          }
          .designation-expertise-container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 0rem;
          }

          .designation-expertise-container span {
            font-family: 'Poppins';
            font-style: normal;
            font-weight: 400;
            font-size: 0.875rem;
            line-height: 1.3125rem;
            color: #33434a;
          }

          .author-details-container {
            display: flex;
          }

          .see-more{
             color:#483287;
             cursor:pointer;
             font-family: 'Poppins';
             font-style: normal;
             font-weight: 400;
             font-size: 1rem;
             line-height: 1.5rem;
          }

          @media screen and (max-width: 950px) {
            .author-profile-parent {
              width:100%;
            }
          }

          @media screen and (max-width: 768px) {
            .author-profile-parent {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              padding: 0rem;
              width:100%;
            }
            .author-heading-container h2 {
              font-size: 1.5rem;
              line-height: 2.25rem;
            }
            .comment-author-avatar {
              min-width: 1.5rem;
              height: 1.5rem;
              margin-right: 0.5rem;
            }
            .expertise span{
              display:none;
            }
            .designation span{
              display:none;
            }
            .designation-expertise-container {
              flex-direction:column;
              margin-top:0px;
            }
            .designation-expertise-container span {
            line-height: 1.125rem;
          }
            .comment-author-avatar img {
              width: 1.5rem;
              height: 1.5rem;
              border-radius: 50%;
            }
            .author-name {
              font-size: 1rem;
              line-height:1.5rem;
            }
            .comment-description {
              font-size: 0.875rem;
              line-height: 1.3125rem;
              padding-top: 0.5rem;
            }
            .author-details-container {
              display: flex;
              flex-direction: column;
            }
            .author-social-profiles {
              margin-left: 0;
            }
            .see-more {
              font-size: 0.875rem;
              line-height: 1.25rem;
            }
            :global(.icon-svg) {
              width: 1.5rem !important;
              height: 1.5rem !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default BlogAuthorProfile2;
